<div class="col-span-12 bg-grey/30  rounded-lg">
  <div class="w-full p-[4.25rem] mx-auto flex flex-col justify-center items-center">
     <div class="bg-white animate-pulse px-[21px] py-5 rounded-full">
       <div class="duration-300">
         <mat-icon class="scale-[2] text-gray-500">info</mat-icon>
       </div>
     </div>
    <div class="w-full text-center animate-pulse  text-gray-400 font-extrabold text-lg">
      {{ title }}
    </div>
  </div>
</div>
